<script setup lang="ts">
import { usePredicateStore } from '@/stores/predicate-store';
import PageSizeMenu from '@/components/atoms/PageSizeMenu.vue';

// The page-size strip (spec 2026-10-16): the menu bound straight to the session's size, which lives in
// the predicate store. It takes no prop and emits no event, because nothing has to be told: whatever
// builds a list's requests reads the same slot and reloads when it changes, so a host only has to put
// the control on screen. How the strip floats over the list is in _page-size-menu.scss.
const predicateStore = usePredicateStore();
</script>

<template>
  <div class="page-size-control">
    <PageSizeMenu v-model="predicateStore.pageSize" />
  </div>
</template>
